import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useRecordContext, useRedirect, useNotify, useGetOne } from "react-admin";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import { StatusLabel } from "../../../components/Label/status";
import InfoRow from "../../../components/Common/InfoRow";
import QuickViewCard from "../../../components/Common/QuickViewCard";
import { formatDate, linkAmount } from "../../../utils/paymentFormat";
import { linkCurrencyLabel } from "./linkCurrency";

// The link's next step (its payment page, or the order it became) and its key facts.
const QuickView = () => {
  const { t }: { t: any } = useTranslation();
  const record = useRecordContext();
  const notify = useNotify();
  const redirect = useRedirect();
  const params = record.params || {};
  const hasOrder = Boolean(record.orderId);
  // The link's own status only says whether it became a transaction; the payment's outcome
  // is the status of that transaction.
  const { data: order, isLoading: orderLoading } = useGetOne("cryptoOrders", { id: record.orderId }, { enabled: hasOrder });

  return (
    <QuickViewCard
      actions={
        hasOrder ? (
          <Button variant="outlined" color="secondary" endIcon={<ArrowForwardRoundedIcon />} onClick={() => redirect("show", "cryptoOrders", record.orderId)}>
            {t("View transaction")}
          </Button>
        ) : (
          record.url && (
            <>
              <Button variant="outlined" color="secondary" endIcon={<OpenInNewRoundedIcon />} onClick={() => window.open(record.url, "_blank")}>
                {t("Open payment page")}
              </Button>
              <Button
                variant="text"
                color="primary"
                startIcon={<ContentCopyOutlinedIcon />}
                onClick={() => {
                  navigator.clipboard.writeText(record.url);
                  notify(t("Link copied to clipboard"), { type: "success" });
                }}
              >
                {t("Copy link")}
              </Button>
            </>
          )
        )
      }
    >
      <InfoRow label={t("Link status")}>
        <StatusLabel fontSize="small" statusField="statusPaymentLink" />
      </InfoRow>
      {hasOrder && (
        <InfoRow label={t("Transaction status")}>
          {orderLoading ? "…" : order ? <StatusLabel fontSize="small" statusField="statusOrder" record={order} /> : "—"}
        </InfoRow>
      )}
      <InfoRow label={t("Amount")}>{linkAmount(params)}</InfoRow>
      <InfoRow label={t("Payment currency")}>{linkCurrencyLabel(params.currency, t)}</InfoRow>
      <InfoRow label={t("Expiration date")}>{formatDate(record.expiresAt)}</InfoRow>
    </QuickViewCard>
  );
};

export default QuickView;
